import Vue from 'vue';
import CustomWatermark from './customWatermark.vue';

const WatermarkPlugin = {
  install(Vue) {
    Vue.prototype.$toggleWatermark = function(visible, options={}) {
      if (visible) {
        // 显示水印
        const watermarkEl = document.createElement('div');
        watermarkEl.id = 'watermark-container';
        document.body.appendChild(watermarkEl);
        new Vue({
          el: watermarkEl,
          render: h => h(CustomWatermark, {props:options})
        });
      } else {
        // 隐藏水印
        const watermarkEl = document.querySelector('.vue_watermark');
        watermarkEl && watermarkEl.remove();
      }
    };
  }
};

export default WatermarkPlugin;



// WEBPACK FOOTER //
// ./src/components/custom_watermark/watermark.js